import * as React from "react";

import { yupResolver } from "@hookform/resolvers/yup";
import { useForm, UseFormReturn, SubmitHandler, UseFormProps } from "react-hook-form";
import * as Yup from "yup";

type FormProps<TFormValues, Schema> = {
  className?: string;
  onSubmit: SubmitHandler<TFormValues>;
  autoComplete: "off" | "on";
  children: (methods: UseFormReturn<TFormValues>) => React.ReactNode;
  options?: UseFormProps<TFormValues>;
  id?: string;
  schema?: Schema;
  noValidate?: boolean;
  sx?: React.CSSProperties;
};

export const Form = <
  TFormValues extends Record<string, unknown> = Record<string, unknown>,
  Schema extends Yup.AnyObjectSchema = Yup.AnyObjectSchema
>({
  onSubmit,
  autoComplete,
  children,
  options,
  id,
  schema,
  noValidate,
  sx,
}: FormProps<TFormValues, Schema>) => {
  const methods = useForm<TFormValues>({ ...options, resolver: schema && yupResolver(schema) });

  return (
    <form
      autoComplete={autoComplete}
      onSubmit={methods.handleSubmit(onSubmit)}
      id={id}
      noValidate={noValidate}
      style={sx}
    >
      {children(methods)}
    </form>
  );
};
